// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2up-W","fullView":"styles_fullView__2ksRb"};